import { Box, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { useEffect, useState } from "react"
import styled from "styled-components"

import fetchOrder from "areas/order/hoc/fetch-order"
import OrderNumber from "areas/order/order-number"
import { IS_GE_CHECKOUT } from "helpers/application"
import Icon from "icon"

import { FormContainer, FormWrapper, MsgWrap, Text } from "../components"
import Heading from "../heading"

import OrderForm from "./order-form"

const StyledMsgWrap = styled(MsgWrap).attrs({
  bg: "rgba(204, 204, 204, 0.2)",
  border: "none",
  display: "flex",
})``

const Return = ({ data }) => {
  const [orderData, setData] = useState(null)
  const is_ge_checkout = IS_GE_CHECKOUT()

  useEffect(() => {
    setData(data)
  }, [data])

  if (orderData && orderData.order) {
    return <OrderForm orderData={orderData} />
  } else {
    return (
      <FormContainer>
        <FormWrapper>
          <Heading rmaType="return" />
          <Text mb={2}>
            Complete this form to return an item you have purchased from{" "}
            {sl.config.site_title} for a refund.
          </Text>

          <StyledMsgWrap>
            <Box>
              <Icon icon="announcement-01" />
            </Box>
            <Box ml="10px">
              <Text fontWeight="500">
                To be eligible for a refund, your item(s) must be in a new and
                unworn condition and be within {is_ge_checkout ? "30" : "99"}{" "}
                days of the original shipping date. If you require assistance,
                please contact customer service at{" "}
                <a
                  className="nowrap"
                  href={`tel:${sl.config.customer_service_toll_free}`}
                >
                  {sl.config.customer_service_toll_free}
                </a>{" "}
                or{" "}
                <a
                  className="nowrap"
                  href={`mailto:${sl.config.customer_service_email}`}
                >
                  {sl.config.customer_service_email}
                </a>
                .
              </Text>
            </Box>
          </StyledMsgWrap>
          <Text>
            Please enter the following required information so we can help you.
          </Text>

          {orderData?.errors && (
            <Typography color="error" mb={2} mt={2}>
              {orderData.errors[0]}
            </Typography>
          )}
        </FormWrapper>
        <OrderNumber
          rmaType="return"
          setData={setData}
          validatePath="/secure/api/v10/order/order_info_for_rma"
        />
      </FormContainer>
    )
  }
}

Return.propTypes = {
  data: PropTypes.object,
}

export default fetchOrder(Return)
